import * as React from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";

import { Metrics, Palette } from "../../vars";

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  href: PropTypes.string
};

export const NavbarDropdownMenuItem: React.SFC<any> = ({
  className,
  children,
  href
}) => (
  <div className={className} role="menuItem" aria-label={children}>
    {href.includes("my-account/home/update-plan/move-house.html") ? (
      <a
        className="analytics-nav"
        href="javascript:void(0)"
        onClick={() => testTarget(href)}
      >
        {children}
      </a>
    ) : (
      <a className="analytics-nav" href={href}>
        {children}
      </a>
    )}
  </div>
);

const testTarget = href => {
  if (
    global.adobe &&
    global.adobe.target &&
    typeof global.adobe.target.getOffer === "function" &&
    typeof global.adobe.target.applyOffer === "function"
  ) {
    global.adobe.target.getOffer({
      mbox: "MA-1",
      success: function(offer) {
        if (offer && offer.length) {
          global.adobe.target.applyOffer({
            mbox: "MA-1",
            selector: "body",
            offer: offer
          });
        } else {
          global.location.pathname = href;
        }
      },
      error: function(status, error) {
        console.error("Error on A/B testing....", status, error);
        location.pathname = href;
      }
    });
  }
};

NavbarDropdownMenuItem.propTypes = propTypes;

export default styled(NavbarDropdownMenuItem)`
  display: block;
  padding: ${Metrics.Padding.NAVBAR_DROPDOWN_MENU_ITEM_Y}px 0;

  a,
  a:visited {
    color: ${Palette.NAVBAR_DROPDOWN_MENU_ITEM_TEXT};
    font-size: ${Metrics.FontSizes.NAVBAR_DROPDOWN_MENU_ITEM_TEXT}px;
    line-height: ${Metrics.LineHeights.NAVBAR_DROPDOWN_MENU_ITEM_TEXT}px;
    text-decoration: none;
  }

  a:hover,
  a:active {
    color: ${Palette.Rebrand.Colours.P2};
  }

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }
`;
